"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumVariationKind = exports.AnnotateProcessLocationSchema = exports.AnnotateProcessLocation = exports.AnnotateSortOrderSchema = exports.AnnotateSortOrder = exports.NameNetsHierarchicallyModeSchema = exports.NameNetsHierarchicallyMode = exports.PowerPortNamesTakePriorityModeSchema = exports.PowerPortNamesTakePriorityMode = exports.HierarchyModeSchema = exports.HierarchyMode = exports.ChannelRoomNamingStyleSchema = exports.ChannelRoomNamingStyle = void 0;
exports.emptyAltiumProjectFile = emptyAltiumProjectFile;
const zod_1 = require("zod");
const AltiumEnums_1 = require("../common/AltiumEnums");
const altiumValidation_1 = require("../../altiumValidation");
function emptyAltiumProjectFile(filename = '') {
    return {
        [altiumValidation_1.AltiumProjectMetadataKey.FileName]: filename,
        Design: {},
        Preferences: {},
        GeneratedDocument: [],
        Configuration: [],
        Document: [],
        Parameter: [],
        DiffPairSuffix: [],
    };
}
var ChannelRoomNamingStyle;
(function (ChannelRoomNamingStyle) {
    ChannelRoomNamingStyle[ChannelRoomNamingStyle["FlatNumericWithNames"] = 0] = "FlatNumericWithNames";
    ChannelRoomNamingStyle[ChannelRoomNamingStyle["FlatAlphaWithNames"] = 1] = "FlatAlphaWithNames";
    ChannelRoomNamingStyle[ChannelRoomNamingStyle["NumericNamePath"] = 2] = "NumericNamePath";
    ChannelRoomNamingStyle[ChannelRoomNamingStyle["AlphaNamePath"] = 3] = "AlphaNamePath";
    ChannelRoomNamingStyle[ChannelRoomNamingStyle["MixedNamePath"] = 4] = "MixedNamePath";
})(ChannelRoomNamingStyle || (exports.ChannelRoomNamingStyle = ChannelRoomNamingStyle = {}));
exports.ChannelRoomNamingStyleSchema = zod_1.default.preprocess(AltiumEnums_1.preprocessEnumValue, zod_1.default.nativeEnum(ChannelRoomNamingStyle));
var HierarchyMode;
(function (HierarchyMode) {
    HierarchyMode[HierarchyMode["Automatic"] = 0] = "Automatic";
    HierarchyMode[HierarchyMode["Flat"] = 1] = "Flat";
    HierarchyMode[HierarchyMode["Hierarchical"] = 2] = "Hierarchical";
    HierarchyMode[HierarchyMode["Global"] = 3] = "Global";
    HierarchyMode[HierarchyMode["StrictHierarchical"] = 4] = "StrictHierarchical";
})(HierarchyMode || (exports.HierarchyMode = HierarchyMode = {}));
exports.HierarchyModeSchema = zod_1.default.preprocess(AltiumEnums_1.preprocessEnumValue, zod_1.default.nativeEnum(HierarchyMode));
var PowerPortNamesTakePriorityMode;
(function (PowerPortNamesTakePriorityMode) {
    PowerPortNamesTakePriorityMode[PowerPortNamesTakePriorityMode["No"] = 0] = "No";
    PowerPortNamesTakePriorityMode[PowerPortNamesTakePriorityMode["Yes"] = 1] = "Yes";
})(PowerPortNamesTakePriorityMode || (exports.PowerPortNamesTakePriorityMode = PowerPortNamesTakePriorityMode = {}));
exports.PowerPortNamesTakePriorityModeSchema = zod_1.default.preprocess(AltiumEnums_1.preprocessEnumValue, zod_1.default.nativeEnum(PowerPortNamesTakePriorityMode).default(PowerPortNamesTakePriorityMode.No));
var NameNetsHierarchicallyMode;
(function (NameNetsHierarchicallyMode) {
    NameNetsHierarchicallyMode[NameNetsHierarchicallyMode["No"] = 0] = "No";
    NameNetsHierarchicallyMode[NameNetsHierarchicallyMode["Yes"] = 1] = "Yes";
})(NameNetsHierarchicallyMode || (exports.NameNetsHierarchicallyMode = NameNetsHierarchicallyMode = {}));
exports.NameNetsHierarchicallyModeSchema = zod_1.default.preprocess(AltiumEnums_1.preprocessEnumValue, zod_1.default.nativeEnum(NameNetsHierarchicallyMode).default(NameNetsHierarchicallyMode.No));
var AnnotateSortOrder;
(function (AnnotateSortOrder) {
    AnnotateSortOrder[AnnotateSortOrder["UpThenAcross"] = 0] = "UpThenAcross";
    AnnotateSortOrder[AnnotateSortOrder["DownThenAcross"] = 1] = "DownThenAcross";
    AnnotateSortOrder[AnnotateSortOrder["AcrossThenUp"] = 2] = "AcrossThenUp";
    AnnotateSortOrder[AnnotateSortOrder["AcrossThenDown"] = 3] = "AcrossThenDown";
})(AnnotateSortOrder || (exports.AnnotateSortOrder = AnnotateSortOrder = {}));
exports.AnnotateSortOrderSchema = zod_1.default.preprocess(AltiumEnums_1.preprocessEnumValue, zod_1.default.nativeEnum(AnnotateSortOrder).default(AnnotateSortOrder.AcrossThenUp));
var AnnotateProcessLocation;
(function (AnnotateProcessLocation) {
    AnnotateProcessLocation[AnnotateProcessLocation["Designator"] = 0] = "Designator";
    AnnotateProcessLocation[AnnotateProcessLocation["Part"] = 1] = "Part";
})(AnnotateProcessLocation || (exports.AnnotateProcessLocation = AnnotateProcessLocation = {}));
exports.AnnotateProcessLocationSchema = zod_1.default.preprocess(AltiumEnums_1.preprocessEnumValue, zod_1.default.nativeEnum(AnnotateProcessLocation).default(AnnotateProcessLocation.Designator));
var AltiumVariationKind;
(function (AltiumVariationKind) {
    AltiumVariationKind[AltiumVariationKind["Fitted"] = 0] = "Fitted";
    AltiumVariationKind[AltiumVariationKind["NotFitted"] = 1] = "NotFitted";
    AltiumVariationKind[AltiumVariationKind["AlternatePart"] = 2] = "AlternatePart";
})(AltiumVariationKind || (exports.AltiumVariationKind = AltiumVariationKind = {}));
//# sourceMappingURL=altiumProjectFileTypes.js.map